module.exports = __webpack_public_path__ + "media/images/Track-eeb212d25d06713a3c17e5a22c36ad2f.png";